import React from "react";
import Link from "next/link";
import { Menu } from "antd";
import { FaChevronDown } from "react-icons/fa";
import Image from "next/legacy/image";
import orangeUnitSrc from "../../public/assets/images/orange_unit.png";
import useFetchData from "@/hooks/useFetchData";
import CategoriesActions from "@/actions/categories";
import { ROUTES } from "@/utils/routes";
import useUI from "@/hooks/useUI";

const { SubMenu } = Menu;

const CategoriesMobile = ({ className, lng }) => {
  const categoriesActions = CategoriesActions();
  const { closeSidebar } = useUI();
  const { data, loading } = useFetchData({
    fetchData: () => categoriesActions.getCategoriesTree({ categoryId: null }),
  });

  const categories = data?.categoriesTree;

  return (
    <Menu
      mode="inline"
      className={className}
      expandIcon={<FaChevronDown />}
      style={{ width: "100%", border: "unset" }}
    >
      {categories?.map((item, index) => (
        <React.Fragment key={item?.id}>
          {item?.subCategories && item?.subCategories?.length ? (
            <SubMenu
              key={item?.id}
              title={
                <div className="flex items-center">
                  <Image
                    src={orangeUnitSrc}
                    alt={`Icon sub - ${item?.id}`}
                    width={14}
                    height={14}
                    className="ml-2"
                  />
                  <Link
                    href={`/${lng}/${ROUTES.STORE}/${item?.id}/${item?.name}`}
                    className="inline-flex items-center text-xl font-bold text-heading hover:text-primary focus:outline-none"
                  >
                    {item?.name}
                  </Link>
                </div>
              }
            >
              {item.subCategories.map((subItem) => (
                <Menu.Item key={subItem?.id} onClick={closeSidebar}>
                  <Link
                    className="text-lg hover:text-primary focus:outline-none"
                    href={`/${lng}/${ROUTES.STORE}/${subItem?.id}/${subItem?.name}`}
                  >
                    {subItem?.name}
                  </Link>
                </Menu.Item>
              ))}
            </SubMenu>
          ) : (
            <Menu.Item
              key={item?.id}
              onClick={closeSidebar}
              // icon={
              //   categories.length - 1 > index && (
              //     <Image
              //       src={orangeUnitSrc}
              //       alt={`Icon - ${item?.id}`}
              //       width={17}
              //       height={17}
              //     />
              //   )
              // }
            >
              <div className="flex items-center">
                <Image
                  src={orangeUnitSrc}
                  alt={`Icon inner - ${item?.id}`}
                  width={14}
                  height={14}
                  className="ml-2"
                />
                <Link
                  href={`/${lng}/${ROUTES.STORE}/${item?.id}/${item?.name}`}
                  className="inline-flex items-center text-lg font-bold text-heading hover:text-primary"
                >
                  {item?.name}
                </Link>
              </div>
            </Menu.Item>
          )}
        </React.Fragment>
      ))}
    </Menu>
  );
};

export default CategoriesMobile;
